import React, { lazy, Suspense, useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';
import 'animate.css';
import './login.css'
import LoginForm from './components/loginForm';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useRouter } from '../../hooks/use-router';
import { useDispatch } from 'react-redux';
import { isLoginFunc } from '../../../store/slices/login';

const VerifyForm = lazy(() => import('./components/verifyForm'));
const OpenForgetPassword = lazy(() => import('./components/openForgetPassword'));
const CreateNewPassword = lazy(() => import('./components/createNewPassword'));

const Login: React.FC = () => {
    const [searchParams] = useSearchParams();
    // step: null (login) | 'forgot' | 'verify' | 'new-password'
    const step = searchParams.get('step');

    const sessionToken = localStorage.getItem("accessToken");
    const location = useLocation();
    const router = useRouter();
    const [isTokenValid, setIsTokenValid] = useState<boolean | null>(null);
    const dispatch = useDispatch();


    useEffect(() => {
        const checkTokenValidity = () => {
            const isInForgotPasswordFlow = step === 'forgot' || step === 'verify' || step === 'new-password';
            if (!sessionToken) {
                setIsTokenValid(false);
                if (!isInForgotPasswordFlow) {
                    router.push("/login")
                }
                return;
            }
            try {
                const tokenPayload = JSON.parse(atob(sessionToken.split('.')[1]));
                const currentTime = Date.now() / 1000;
                dispatch(isLoginFunc(true));
                setIsTokenValid(tokenPayload.exp > currentTime); // Token geçerliyse true, değilse false
            } catch (error) {
                console.error("Token geçerliliği kontrol edilirken bir hata oluştu:", error);
                setIsTokenValid(false);
            }
        };
        checkTokenValidity();
    }, [sessionToken, step, router, dispatch]);

    useEffect(() => {
        const isInForgotPasswordFlow = step === 'forgot' || step === 'verify' || step === 'new-password';
        if (isTokenValid === false) {
            // Şifre sıfırlama akışındaysak localStorage'ı temizleme; verifyToken'a ihtiyaç var.
            if (!isInForgotPasswordFlow) {
                localStorage.clear();
                router.push("/login");
            }
        } else if (isTokenValid === true && location.pathname === "/login") {
            // Şifre sıfırlama sub-form'larındaysak dokunma; oturum açıksa anasayfaya al.
            if (!isInForgotPasswordFlow) {
                router.back();
            }
        }
    }, [isTokenValid, location.pathname, router, step]);



    const renderForm = () => {
        if (step === 'new-password') return <CreateNewPassword />;
        if (step === 'verify') return <VerifyForm />;
        if (step === 'forgot') return <OpenForgetPassword />;
        return <LoginForm />;
    };



    return (
        <>
            <div className='gradient' />
            <Box className="login-page" sx={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: { xs: "column", md: "row" } }}>
                <Stack className="logo-side" sx={{ width: { xs: "70%", md: "40%" } }} >
                    <img className="animate__animated animate__backInDown  logo_mark" alt={"logo_mark"} src={process.env.PUBLIC_URL + "/assets/logo/logo_motto.svg"} />
                </Stack>
                <div className="login-verify-cover">
                    <Suspense fallback={<CircularProgress sx={{ color: 'white' }} />}>
                        {renderForm()}
                    </Suspense>
                </div>
                <div className="login-footer">
                    <p className="footer_year">
                        © 2024
                    </p>
                    <a href="https://www.ahlpay.com.tr/" className="footer__ahlpay-text">
                        AHLPAY
                    </a>
                </div>
            </Box >
        </>

    );
}

export default Login;
